var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 7,
    fill: "url(#paint0_linear_1_641)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4447 31.8317C19.4447 31.8317 19.4453 31.8321 20 31L20.5547 31.8321C20.2188 32.056 19.7806 32.0556 19.4447 31.8317Z",
    fill: "#007675"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 14C17.7908 14 16 15.7909 16 18C16 20.2091 17.7908 22 20 22C22.2091 22 24 20.2091 24 18C24 15.7909 22.2091 14 20 14ZM18 18C18 16.8954 18.8954 16 20 16C21.1045 16 22 16.8954 22 18C22 19.1046 21.1045 20 20 20C18.8954 20 18 19.1046 18 18Z",
    fill: "#007675"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4447 31.8317L20 31C20.5547 31.8321 20.556 31.8312 20.556 31.8312L20.5581 31.8298L20.5647 31.8253L20.5877 31.8098C20.6071 31.7966 20.6349 31.7776 20.6704 31.753C20.7414 31.7038 20.8435 31.6321 20.9722 31.5392C21.2294 31.3534 21.5936 31.0822 22.0291 30.7354C22.8986 30.043 24.0606 29.0428 25.2259 27.8127C27.5157 25.3958 30 21.9019 30 18C30 15.3478 28.9464 12.8043 27.071 10.9289C25.1957 9.05357 22.6521 8 20 8C17.3478 8 14.8043 9.05357 12.9289 10.9289C11.0535 12.8043 9.99997 15.3478 9.99997 18C9.99997 21.9019 12.4842 25.3958 14.774 27.8127C15.9394 29.0428 17.1013 30.043 17.9708 30.7354C18.4063 31.0822 18.7705 31.3534 19.0278 31.5392C19.1564 31.6321 19.2585 31.7038 19.3295 31.753C19.365 31.7776 19.3928 31.7966 19.4123 31.8098L19.4352 31.8253L19.4419 31.8298L19.4447 31.8317ZM14.3431 12.3431C15.8434 10.8429 17.8782 10 20 10C22.1217 10 24.1565 10.8429 25.6568 12.3431C27.1571 13.8434 28 15.8783 28 18C28 21.0981 25.9842 24.1042 23.774 26.4373C22.6894 27.5822 21.6013 28.5195 20.7833 29.1708C20.4789 29.4133 20.2129 29.6152 20 29.7726C19.787 29.6152 19.5211 29.4133 19.2166 29.1708C18.3986 28.5195 17.3106 27.5822 16.2259 26.4373C14.0157 24.1042 12 21.0981 12 18C12 15.8783 12.8428 13.8434 14.3431 12.3431Z",
    fill: "#007675"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_641",
    x1: 49.5,
    y1: 40,
    x2: -10.5,
    y2: 2.49999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007675",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007675",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8a6c0b105d526acaaec55a1f4020c980.svg";
export { ForwardRef as ReactComponent };